module.exports = __webpack_public_path__ + "img/paypal.80c96535.jpg";